import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import BottomSheet from 'Components/BottomSheet';
import useModalState from 'utils/hooks/useModalState';
import { Flex } from '@igooods/ui-kit';
import { FontFamily } from 'theme';
import { colors } from 'constants/colors';
import Title from 'Components/Typography/Title';
import Text from 'Components/Typography/Text';
import { HIDE_MOBILE_APP } from 'constants/cookie';
import Cookies from 'js-cookie';
import mobileAppImg from './img/mobileApp.png';
import mobileAppImg2x from './img/mobileApp2x.png';
import { mediaCustomDown } from 'theme/helpers/css';
import MarketplaceButton from './MarketplaceButton';

export const MOBILE_APP_TEST_ID = 'MOBILE_APP_TEST_ID';
export const MOBILE_APP_BTN_TEST_ID = 'MOBILE_APP_BTN_TEST_ID';

const Description = styled(Text)`
  font-size: 14px;
  line-height: 18px;
  margin: 6px auto 20px;
  ${mediaCustomDown(580)`
    max-width: 320px;
  `}
  ${mediaCustomDown(321)`
    display: none;
  `}
`;

const Container = styled(Flex).attrs({ column: true, between: true })`
  height: 100%;

  img {
    object-fit: contain;
    margin: 0 auto;
    width: 100%;
    ${mediaCustomDown(321)`
    height: 118px;
  `}
  }
`;

const StyledTitle = styled(Title).attrs({
  fontFamily: FontFamily.secondFont,
  color: colors.blackRussian,
  center: true,
})`
  font-size: 20px;
  line-height: 28px;
  margin-top: 25px;
`;

const INITIAL_HEIGHT = 280;
const SMALL_HEIGHT = 200;

const MobileApp = () => {
  const { isVisible, showModal, hideModal } = useModalState();
  const [heightImg, setHeightImg] = useState(INITIAL_HEIGHT);
  useEffect(() => {
    window.addEventListener('load', () => {
      !Cookies.get(HIDE_MOBILE_APP) && showModal();
    });

    if (window.innerHeight < 668) {
      setHeightImg(SMALL_HEIGHT);
    }
  }, [showModal]);

  const handleClose = () => {
    Cookies.set(HIDE_MOBILE_APP, 'true', { domain: '.igooods.ru' });
  };

  const handleClick = () => {
    handleClose();
    hideModal();
  };

  return (
    <BottomSheet
      {...{ isOpen: isVisible, open: showModal, close: hideModal }}
      snapPoint={0}
      snapPointToTop={70}
      onCollapsed={handleClose}
      hidden
    >
      <Container data-testid={MOBILE_APP_TEST_ID}>
        <Flex column>
          <picture>
            <source srcSet={`${mobileAppImg2x} 2x, ${mobileAppImg} 1x`} />
            <img src={mobileAppImg} alt="mobile app" height={heightImg} />
          </picture>

          <StyledTitle>Заказывайте продукты в&nbsp;приложении</StyledTitle>
          <Description center>Любимые продукты и&nbsp;статусы заказов всегда под рукой</Description>
        </Flex>
        <MarketplaceButton onClick={handleClick} testId={MOBILE_APP_BTN_TEST_ID} />
      </Container>
    </BottomSheet>
  );
};

export default MobileApp;
